<div class="sponsors-report-dialog">
  <div mat-dialog-title class="sponsors-report-dialog__header">
    <div class="sponsors-report-dialog__context">Exportação</div>
    <h1 class="sponsors-report-dialog__title">Configurar PDF</h1>
  </div>

  <div mat-dialog-content class="sponsors-report-dialog__content">
    <div class="sponsors-report-dialog__layout">
      <section class="sponsors-report-dialog__section">
        <div class="sponsors-report-dialog__section-head">
          <h2>Responsável</h2>
        </div>

        <mat-form-field class="sponsors-report-dialog__field" appearance="outline">
          <mat-label>Colaborador</mat-label>
          <mat-select [ngModel]="selectedCollaboratorId"
            (ngModelChange)="onSelectChange($event)">
            <mat-option value="">Todos</mat-option>
            @for (option of options; track option) {
              <mat-option [value]="option.value">
                {{option.label}}
              </mat-option>
            }
            @if (isUsersDropdownLoading) {
              <mat-option disabled>A carregar colaboradores...</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </section>

      <section class="sponsors-report-dialog__section">
        <div class="sponsors-report-dialog__section-head">
          <h2>Ordenação</h2>
        </div>

        <mat-form-field class="sponsors-report-dialog__field" appearance="outline">
          <mat-label>Ordenar por</mat-label>
          <mat-select [(ngModel)]="selectedSortBy">
            <mat-option value="name">Nome</mat-option>
            <mat-option value="value">Valor (maior primeiro)</mat-option>
          </mat-select>
        </mat-form-field>
      </section>

      <section class="sponsors-report-dialog__section">
        <div class="sponsors-report-dialog__section-head">
          <h2>Listagens e filtros</h2>
        </div>

        <div class="sponsors-report-dialog__options">
          <mat-checkbox [(ngModel)]="selectedOptions[2]" [value]="'2'">
            Listar pagos
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedOptions[3]" [value]="'3'">
            Listar prometidos
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedOptions[4]" [value]="'4'">
            Listar a contactar
          </mat-checkbox>
          @if (selectedOptions[2] || selectedOptions[3]) {
            <mat-checkbox [(ngModel)]="selectedOptions[5]" [value]="'5'">
              Esconder valor
            </mat-checkbox>
          }
          @if (selectedOptions[2] || selectedOptions[3] || selectedOptions[4]) {
            <mat-checkbox [(ngModel)]="selectedOptions[6]" [value]="'6'">
              Filtrar por datas
            </mat-checkbox>
          }
          @if (selectedOptions[2] || selectedOptions[3]) {
            <mat-checkbox [(ngModel)]="selectedOptions[7]" [value]="'7'">
              Intervalo de valores
            </mat-checkbox>
          }
          <mat-checkbox [(ngModel)]="selectedOptions[8]" [value]="'8'">
            Apenas com publicidade
          </mat-checkbox>
        </div>

        <div class="sponsors-report-dialog__fields">
          @if (selectedOptions[6]) {
            <mat-form-field class="sponsors-report-dialog__field" appearance="outline">
              <mat-label>Datas</mat-label>
              <mat-date-range-input [rangePicker]="dateRangePicker">
                <input matStartDate placeholder="Data de início" [(ngModel)]="startDate">
                <input matEndDate placeholder="Data final" [(ngModel)]="endDate">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
          }

          @if (selectedOptions[7]) {
            <div class="sponsors-report-dialog__values-grid">
              <mat-form-field class="sponsors-report-dialog__field" appearance="outline">
                <mat-label>Mínimo</mat-label>
                <input matInput type="number" [(ngModel)]="minValue">
              </mat-form-field>
              <mat-form-field class="sponsors-report-dialog__field" appearance="outline">
                <mat-label>Máximo</mat-label>
                <input matInput type="number" [(ngModel)]="maxValue">
              </mat-form-field>
            </div>
          }
        </div>
      </section>
    </div>
  </div>

  <div mat-dialog-actions class="sponsors-report-dialog__actions">
    <button
      mat-stroked-button
      type="button"
      class="sponsors-report-dialog__button sponsors-report-dialog__button--secondary"
      [mat-dialog-close]="false">
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="sponsors-report-dialog__button sponsors-report-dialog__button--primary"
      (click)="confirmSelection()">
      Exportar PDF
    </button>
  </div>
</div>
